export default __webpack_public_path__ + "static/media/img4.d11e8c76.jpg";